import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { COURSE_EVENTS } from '../../values/events';
import { SectionsProvider } from '../../providers/sections.provider';
import KEYS from '@/values/keys';
import EdSectionObjectHomeworkInfo from '@/courses/components/ed-section-object-homework-info/ed-section-object-homework-info.vue';
import ToolService from '@/providers/tools';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import { ProjectsMixin } from '@/courses/mixins/projects.mixin';
 
@Component({
  name: 'ed-section-projects-object',
  components: {
    EdSectionObjectHomeworkInfo
  }
})
export default class EdSectionProjectsObject extends Mixins(ProjectsMixin) {

  /* Props */
  @Prop() readonly parentId: number;
  @Prop() readonly level: number;

  /* Data */
  public selected: boolean = false;
  public objectID: string = '';
  public isLoading: boolean = false;

  /* Computed */
  get loading() {
    return this.isLoading || this.project.loading 
  }

  get membersConnected() {
    return this.$store.state.AppStore.membersPosition.filter(m => {
      return (
        m.courseId == this.courseID && 
        m.classId == this.classID &&
        m.sectionId == this.project.projectId
      );
    });
  }

  get classes() {
    let padding = `edg-pad-left--${this.level * 10}`;
    return { 
      'ed-section-projects-object--edition':  this.options.editable,
      'edg-cur--grab':  this.options.draggable,
      'edg-cur--pointer': this.options.selectable,
      'ed-section-projects-object--selected': this.options.selectable && this.selected,
      [padding]: true
    }
  }

  get nameSectionStyle() {
    let nameSectionStyle = this.options.editable ? {
      maxWidth: `calc(100% - ${this.level * 20}px)`
    } : {};
    return nameSectionStyle
  }

  get nameStyle() {
    return { maxWidth: `calc(100% - ${(this.membersConnected.length * 15)}px` };
  }

  get escapedName() {
    return ToolService.exitSpecialChars(this.project.section?.name);
  }

  get teacherOnly() {
    let parent = SectionsProvider.getSectionByID(this.course.projects, this.parentId);
    if(parent) {
      return parent.section?.teacherOnly ? parent.section?.teacherOnly : this.project.section?.teacherOnly;
    } else {
      return false;
    }
  }

  get projectSectionType() {
    return this.project.section?.type || null;
  }

  get projectSectionName() {
    return this.project.section?.name || null;
  }

  /* Methods */
  async removeObject() {
    let data = {projectId: this.project.projectId, 
    courseId: this.courseID, classId: this.classID};
    this.isLoading = true;
    await this.removeProject(data);
    this.isLoading = false; 
  }

  setSelected({ projectId, courseId = -1 , classId}) {
    if(this.options.selectable) {
      let classIdCondition: boolean = this.options.editable ? true : classId == this.classID;
      if(this.courseID == courseId && classIdCondition) {
        this.selected = this.project.projectId === projectId;
      }
    }
  }

  openObject(emitScreenMirroringEvent : boolean = true) {
    if(this.options.selectable) {     
      // Enviando el section id a presentation mode -> TODO: revisar   
      let dataPreview = {projectId: this.project.projectId , courseId: this.courseID , classId: this.classID, title: this.course.title};
      let dataPreviewPresent = {sectionId: this.project.section['id'] , courseId: this.courseID , classId: this.classID, title: this.course.title};
      this.$edEventBus.$emit(COURSE_EVENTS.LOAD_PRESENTATION_COURSE_SECTION, dataPreviewPresent);
      this.goToProjectPreview(dataPreview);
      if(!this.options.editable) {
        this.setSectionInStorage(this.project.projectId);
      }
    }

    if( emitScreenMirroringEvent ) {
      var target = this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_PROJECT_OBJECT);
      this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.CLICK, this, {target:target});
    }
  }

  target(screenMirroringEventName:string) {
    return screenMirroringEventName.replace('{projectId}', this.project.projectId.toString());
  }

  /* Hooks */
  created() {
    this.objectID = `${KEYS.PRE_PROJECT_OBJECT_ID}${this.project.projectId}`;
    this.$edEventBus.$on(COURSE_EVENTS.OBJECT_SELECTED, this.setSelected);
    this.$edEventBus.$on(this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_PROJECT_OBJECT), (args:any) => { this.openObject(false); });
  }

  beforeDestroy(): void {
    this.$edEventBus.$off(this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_PROJECT_OBJECT));
  }

}
